import React, { useState } from 'react';
import Classes from './Product.module.css';

export default function ProductItem({ index, img, product, activeImage, setActiveImage }) {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div

            onClick={() => setActiveImage(index)}
        >
            {!isLoaded && (
                <img
                    src="/images/placeholder-small.png"
                    alt="placeholder"
                    draggable={false}
                    className={`${index === activeImage ? Classes.activeThumbnail : ''}`}
                />
            )}
            <img
                src={img}
                alt={`${product.title} view ${index + 1}`}
                draggable={false}
                rel="noopener noreferrer"
                className={`${index === activeImage ? Classes.activeThumbnail : ''} ${!isLoaded ? Classes.hidden : ''}`}
                onLoad={() => setIsLoaded(true)}
            />
        </div>
    );
}
